import React, {useContext} from 'react';
import TrainerLayout from './TrainerLayout';
import NotificationsBell from "../commons/NotificationsBell";
import {TrainerContext} from "../../context/TrainerContext";
import '../../styles/TrainerDashboard.css'; // Import the CSS file

const TrainerDashboard = () => {
    const { trainer } = useContext(TrainerContext); // ✅ Pobieramy dane z kontekstu

    return (
        <TrainerLayout>
            <div className="page-container">
                <div className="dashboard-header">
                    <div className="header-left">
                        <h1>Witaj, trenerze!</h1>
                        <p>To jest Twój pulpit trenera.</p>
                    </div>
                    <div className="header-right">
                    </div>
                </div>
                {/* Add additional dashboard content here */}
            </div>
        </TrainerLayout>
    );
};

export default TrainerDashboard;